/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ContactCenterSmsInboxItemDto = {
    id: number;
    channel: ContactCenterSmsInboxItemDto.channel;
    body: string;
    /**
     * Patient primary key when the inbound number matched a referral; otherwise null
     */
    patientId: number | null;
    /**
     * Patient.internalId when patient is known; otherwise null (display in inbox UI)
     */
    patientInternalId: number | null;
    /**
     * Inbound caller/sender phone number (E.164) for call and SMS inbox items
     */
    patientPhoneNumber: string;
    /**
     * Labels from AI classify when present
     */
    classification?: Array<string>;
    /**
     * Message created timestamp (ISO)
     */
    createdAt?: string;
    /**
     * Referral UUID for patient profile when this patient has exactly one referral; null if none or if hasMultipleReferrals
     */
    referralId?: string | null;
    /**
     * Latest AI reply text from response_reply for this inbound message when present (rows with status err_response are omitted)
     */
    reply?: string | null;
    /**
     * Denial reason on the latest non-err_response response_reply when the user denied the AI draft
     */
    denialReason?: string | null;
    /**
     * From message row: true when inbound handling marked multiple referrals; referralId is then null
     */
    hasMultipleReferrals: boolean;
    /**
     * Whether the message has been read in the inbox
     */
    isRead: boolean;
    /**
     * Whether the inbox item is marked done
     */
    isDone: boolean;
    /**
     * Outbound SMS message id that answered this inbound inbox item
     */
    sentReplyMessageId?: number | null;
    /**
     * Actual SMS body sent to the patient for this inbox item
     */
    sentReplyBody?: string | null;
    /**
     * Timestamp when the linked outbound SMS response was saved
     */
    sentReplyCreatedAt?: string | null;
    /**
     * Presigned S3 recording URL for call inbox items
     */
    recordingUrl?: string | null;
    /**
     * English translation of a non-English voicemail transcript when available
     */
    englishText?: string | null;
    /**
     * True when at least one classification correction has been reported for this message
     */
    hasClassificationCorrection: boolean;
    /**
     * True when the saved report includes a translation issue description
     */
    hasTranslationReport: boolean;
    /**
     * True when the saved report includes a transcription issue description
     */
    hasTranscriptionReport: boolean;
}

export namespace ContactCenterSmsInboxItemDto {

    export enum channel {
        SMS = 'sms',
        EMAIL = 'email',
        CALL = 'call',
    }


}
